module.exports = __webpack_public_path__ + "static/img/fb.e34e765.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/common/fb.png
// module id = RmCk
// module chunks = 7